import { useCallback, useState } from 'react';
import { abortAssistantMessageGeneration as abortAssistantMessageGenerationHttp } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
export const useAbortAssistantMessageGeneration = _ref => {
  let {
    httpClient
  } = _ref;
  const [abortAssistantMessageGenerationStatus, setAbortAssistantMessageGenerationStatus] = useState({});
  const abortAssistantMessageGeneration = useCallback(async userMessageId => {
    setAbortAssistantMessageGenerationStatus(prevState => ({
      ...prevState,
      [userMessageId]: 'aborting'
    }));
    try {
      await httpClient.request(abortAssistantMessageGenerationHttp({
        userMessageId
      }));
      setAbortAssistantMessageGenerationStatus(prevState => ({
        ...prevState,
        [userMessageId]: 'aborted'
      }));
    } catch (error) {
      setAbortAssistantMessageGenerationStatus(prevState => ({
        ...prevState,
        [userMessageId]: undefined
      }));
    }
  }, [httpClient]);
  return {
    abortAssistantMessageGeneration,
    abortAssistantMessageGenerationStatus
  };
};
//# sourceMappingURL=useAbortAssistantMessageGeneration.js.map